import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../utils/supabaseClient';

const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
    const [state, setState] = useState({
        token: null,
        session: null,
        user: null,
        oid: null,
        email: null,
        // idTokenClaims kept for backward compat — sub and oid both map to Supabase user UUID
        idTokenClaims: null,
        loading: true,
        error: null,
    });

    useEffect(() => {
        // Get initial session on mount
        supabase.auth.getSession().then(({ data: { session } }) => {
            setState(buildState(session, false));
        });

        // Keep in sync with auth state changes (sign in, sign out, token refresh)
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            setState(buildState(session, false));
        });

        return () => subscription.unsubscribe();
    }, []);

    return (
        <TokenContext.Provider value={state}>
            {children}
        </TokenContext.Provider>
    );
};

function buildState(session, loading) {
    const user = session?.user ?? null;
    return {
        token: session?.access_token ?? null,
        session: session ?? null,
        user,
        oid: user?.id ?? null,
        email: user?.email ?? null,
        // Provide idTokenClaims shape that existing code expects (sub + oid)
        idTokenClaims: user
            ? { sub: user.id, oid: user.id, email: user.email }
            : null,
        loading,
        error: null,
    };
}

export const useAuth = () => {
    const context = useContext(TokenContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within a TokenProvider');
    }
    return context;
};

export { TokenContext };
